import axios from "axios";
import { API_BASE_URL } from "../../config/Config";

// <----------------- User Register ----------------------->
export const Sub_Category_List = async (User_register_data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/sub-category-list`, User_register_data)
        return response
    } catch (error) {
        return error
    }
}


export const Category_List = async (User_register_data) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/category-list`)
        return response
    } catch (error) {
        return error
    }
}
// <-------- Product List ------------------->
export const Product_List_Data = async ({category_id, subcategory_id, origin_id, shape_id, color_id, treatment_id, min_amount, max_amount,  cut_id,
certificate_id, composition_id }) => {

    console.log("category_id", category_id);
        console.log("subcategory_id", subcategory_id);

    try {
        const response = await axios.get(`${API_BASE_URL}/web-product-list`, {
            params: {
                category_id,
                subcategory_id,
                is_best: "1",
                origin_id,
                shape_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount,
                cut_id,
                certificate_id,
                composition_id
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Product List ------------------->
export const Get_Product_Details = async ({ slug }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-product-list`, {
            params: {
                slug
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Get_Product_list ------------->
export const Get_Product_List = async ({category_id, subcategory_id, is_best, origin_id, shape_id, cut_id, certificate_id, composition_id, color_id, treatment_id, min_amount, max_amount }, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/product-list`, {
            params: {
               category_id,
               subcategory_id,
                is_best: "1",
                origin_id,
                shape_id,
                cut_id,
                certificate_id,
                composition_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Get_Product_list ------------->
export const Get_Product_List_Category_wise = async ({ category_id, subcategory_id, origin_id, shape_id, color_id, cut_id, composition_id, certificate_id, treatment_id, min_amount, max_amount }, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/product-list`, {
            params: {
                category_id,
                subcategory_id,
                origin_id,
                shape_id,
                color_id,
                cut_id,
                certificate_id,
                composition_id,
                treatment_id,
                min_amount,
                max_amount
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Get_Product_list ------------->
export const Product_List_Data_Category_wise = async ({ category_id, subcategory_id, origin_id, shape_id, color_id, treatment_id, min_amount, max_amount,  cut_id,certificate_id,composition_id }, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-product-list`, {
            params: {
                category_id,
                subcategory_id,
                origin_id,
                shape_id,
                color_id,
                treatment_id,
                min_amount,
                max_amount,
                cut_id,
                certificate_id,
                composition_id
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Product List ------------------->
export const Add_To_Cart = async (add_to_cart_data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-to-cart`, add_to_cart_data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- Get_Cart_List ------------------->
export const Get_Cart_List = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/cart-list`, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};
// <------------ Remove_Cart_List -------------->
export const Remove_Cart_List = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/remove-cart`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <------------ Remove_Cart_List -------------->
export const Update_Cart_List = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update-cart`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <------------ Remove_Cart_List -------------->
export const Coupan_Code = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/coupon-check`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <--------- shipping-address ------------->
export const Shipping_Address = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/shipping-address`, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <--------- shipping-address ------------->
export const Add_Shipping_Address = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-shipping-address`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <--------- shipping-address ------------->
export const Remove_Shipping_Address = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/remove-shipping-address`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <--------- shipping-address ------------->
export const Update_Shipping_Address = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update-shipping-address`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

export const Default_Shipping_Address = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/default-address`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <--------- order-place ------------->
export const Submit_Order_Place = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/order-place`, data, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};

// <--------- order-place ------------->
export const Get_Order_List = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/order-list`, { headers: headers });
        return response;
    } catch (error) {
        return error;
    }
};
// <--------- order-place ------------->
export const Get_Order_Details = async (orderId, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/order-details`, {
            params: { orderId },
            headers,
        });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return Promise.reject(error);
    }
};

// <-------- add-to-fav       ------------->
export const Add_To_Fav = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-to-fav`, data, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};
// <-------- add-to-fav       ------------->
export const Add_To_Review = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-product-review`, data, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

export const Edit_Product_Review = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-product-review`, data, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const Get_Wallet_Details = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/wallet-detail`, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const wallet_amount_flag = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/wallet-amount-flag`, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const add_wallet = async (data, headers) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/add-wallet`, data, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const get_wallet_history = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/wallet-history`, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const get_favourite_product_list = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/favourite-product-list`, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const web_user_dashboard = async (headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/web-user-dashboard`, { headers: headers });
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};

// <--------- wallet-detail -------------->
export const get_return_policy = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/return-policy`);
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};


export const get_shop_with_us = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/why-shop-with-us`);
        return response;
    } catch (error) {
        console.error("Error fetching order details:", error);
        return error;
    }
};


export const Get_Product_Type = async ({id, category_id, subcategory_id,}, headers) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/product-list`, {
            params: {
                id,
                category_id,
                subcategory_id,
                
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};


export const Get_Product_Detail_Auth = async ({slug}, headers) => {
    // console.log("id", id);
    //     console.log("category_id", category_id);
    //     console.log("subcategory_id", subcategory_id);

    try {
        const response = await axios.get(`${API_BASE_URL}/product-list`, {
            params: {
                slug
            }
            , headers: headers
        }
        );
        return response;
    } catch (error) {
        return error;
    }
};

// <-------- order-to-cancel       ------------->
export const Order_Cancel = async (data, headers) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/order-cancel`, 
            data, 
            { headers: { 'Content-Type': 'application/json', ...headers } }
        );
        return response;
    } catch (error) {
        console.error("Error cancelling order:", error);
        return error;
    }
};

export const Order_Return = async (data, headers) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/order-return`, 
            data, 
            { headers: { ...headers } }
        );
        return response;
    } catch (error) {
        console.error("Error cancelling order:", error);
        return error;
    }
};
